import Grid from "@mui/material/Grid2";
import React from "react";
import PropertyTab from "./PropertyTab";
import PlanOptionsTab from "./PlanOptionsTab";
import BoilerTab from "./BoilerTab";
import AddressTab from "../../../../../../../Shared/AddressTab";
import TabPanel from "../../../../../../../Shared/TabPanel";
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";
import AddressSwitch from "../../../../../../../Shared/AddressSwitch";
import SideTabs from "./SideTabs";
import PromoTab from "./PromoTab";
import { useCarePlanPlanDetailsSideTab } from "../../../../../../../../hooks/sideTabs/useCarePlanPlanDetailsSideTab";
import { validateTab } from "@utils/general";

const name = "CarePlanDetails";
const prefix = "CarePlanPlanDetails";

/**
 * Component for displaying various details of a care plan.
 * It includes different tabs like Plan Type, Address, Property, Boiler, and Promotional Discounts.
 *
 * @param {Object} props - Component props.
 * @param {string} props.parent - The parent component's name for debugging purposes.
 * @returns {JSX.Element} - The rendered component with multiple tabs.
 */
const CarePlanDetails: React.FC<Props> = ({ parent }) => {
  const { sideTabsIndexes, isBoiler, serviceAgreementPolicyTab, sideTabsStates } = useCarePlanPlanDetailsSideTab();

  const debugName = `${parent}▷[${name}]`;

  React.useEffect(() => {
    // carePlanValid();
    validateTab("CarePlanPlanDetails");
  }, [sideTabsStates]);

  // Use custom hook for debug information
  useDebugInformation(debugName, { prefix, serviceAgreementPolicyTab, sideTabsIndexes, isBoiler });

  return (
    <Grid container>
      <SideTabs parent={debugName} prefix={prefix} />
      <TabPanel
        parent={debugName}
        value={serviceAgreementPolicyTab}
        index={sideTabsIndexes.PLAN_OPTIONS_SIDE_TAB}
        style={{ marginBottom: 12, minHeight: 345 }}
      >
        <PlanOptionsTab />
      </TabPanel>
      <TabPanel
        parent={debugName}
        value={serviceAgreementPolicyTab}
        index={sideTabsIndexes.ADDRESS_SIDE_TAB}
        style={{ marginBottom: 12, minHeight: 345 }}
      >
        <AddressTab parent={debugName} prefix={`${prefix}Address`}>
          <div style={{ display: "flex" }}>
            <AddressSwitch parent={debugName} prefix={`${prefix}Address`} />
          </div>
        </AddressTab>
      </TabPanel>
      <TabPanel
        parent={debugName}
        value={serviceAgreementPolicyTab}
        index={sideTabsIndexes.PROPERTY_SIDE_TAB}
        style={{ marginBottom: 12, minHeight: 345 }}
      >
        <PropertyTab parent={debugName} />
      </TabPanel>
      {isBoiler && (
        <TabPanel
          parent={debugName}
          value={serviceAgreementPolicyTab}
          index={sideTabsIndexes.BOILER_SIDE_TAB}
          style={{ marginBottom: 12, minHeight: 345 }}
        >
          <BoilerTab parent={debugName} />
        </TabPanel>
      )}
      <TabPanel
        parent={debugName}
        value={serviceAgreementPolicyTab}
        index={sideTabsIndexes.PROMO_DISCOUNT_SIDE_TAB}
        style={{ marginBottom: 12, minHeight: 345 }}
      >
        <PromoTab parent={debugName} />
      </TabPanel>
    </Grid>
  );
};

export default CarePlanDetails;

type Props = {
  parent: string;
};
